import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ViewMessage.css';

function ViewMessage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [messageExists, setMessageExists] = useState(false);

  useEffect(() => {
    const checkMessage = async () => {
      try {
        const response = await fetch(`/api/messages.php?token=${id}&action=check`);
        const data = await response.json();

        if (response.ok && data.exists) {
          setMessageExists(true);
          setShowConfirmation(true);
        } else {
          setError('Message not found or expired');
        }
      } catch (err) {
        console.error('Error checking message:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    checkMessage();
  }, [id]);

  const fetchMessage = async () => {
    try {
      const response = await fetch(`/api/messages.php?token=${id}&action=fetch`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Message not found or expired');
      }
      
      setMessage(data.content);
    } catch (err) {
      console.error('Error fetching message:', err);
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleShowMessage = () => {
    setShowConfirmation(false);
    fetchMessage();
  };

  if (loading) {
    return (
      <div className="message-container">
        <h2>Checking message...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/')} className="home-button">
          Back to Home
        </button>
      </div>
    );
  }

  if (showConfirmation && messageExists) {
    return (
      <div className="confirmation-container">
        <h2>Important Information</h2>
        <p>This message will be deleted immediately after viewing and cannot be read again.</p>
        <p>Do you want to view the message now?</p>
        <div className="button-container">
          <button onClick={handleShowMessage} className="show-button">Show Message</button>
          <button onClick={() => navigate('/')} className="cancel-button">Cancel</button>
        </div>
      </div>
    );
  }

  if (message) {
    return (
      <div className="message-container">
        <h2>Your Message</h2>
        <div className="message-content">
          <p>{message}</p>
        </div>
        <button onClick={() => navigate('/')} className="home-button">
          Back to Home
        </button>
      </div>
    );
  }

  return null;
}

export default ViewMessage; 